import { render, staticRenderFns } from "./CodeQuery.vue?vue&type=template&id=fa661e16&scoped=true"
import script from "./CodeQuery.vue?vue&type=script&lang=js"
export * from "./CodeQuery.vue?vue&type=script&lang=js"
import style0 from "./CodeQuery.vue?vue&type=style&index=0&id=fa661e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa661e16",
  null
  
)

export default component.exports